module.exports = __webpack_public_path__ + "static/media/tourism-boards-5.8378e08c.jpg";